import { schema } from 'normalizr';
import { tagUnionSchema } from './tagSchema';
import { extractAllTags } from './tagHelpers';

export const recommendationSchema = new schema.Entity(
  'recommendations',
  {
    program: {
      subcategories: [tagUnionSchema],
      university: tagUnionSchema,
    },
  },
  {
    idAttribute: 'uuid',
    processStrategy: recommendation => {
      recommendation.matchPercentage = Math.round(
        recommendation.probability_fit * 100
      );
      return {
        ...recommendation,
        tags: extractAllTags(recommendation),
      };
    },
  }
);

export const recommendationListSchema = [recommendationSchema];



// WEBPACK FOOTER //
// ./src/schema/recommendationSchema.js